import { ReactNode } from 'react';
import './TicketProposal.scss';

type TicketStatusVariant = 'success' | 'cancelled' | 'error';

const ICON_PATH_BY_VARIANT: Record<TicketStatusVariant, string> = {
  success: 'M5 13l4 4L19 7',
  cancelled: 'M6 18L18 6M6 6l12 12',
  error: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
};

interface TicketStatusCardProps {
  variant: TicketStatusVariant;
  title?: string;
  copy?: string;
  actions?: ReactNode;
}

// Shared presentational card for the terminal states of the ticket flow.
// Success and cancelled announce politely via role="status"; error is assertive
// via role="alert" and renders an action row.
export function TicketStatusCard({ variant, title, copy, actions }: TicketStatusCardProps) {
  const isError = variant === 'error';
  return (
    <div
      className={`support-ticket-card support-ticket-card--${variant}`}
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? undefined : 'polite'}
    >
      <div className={`support-ticket-status-row${isError ? ' support-ticket-status-row--error' : ''}`}>
        <svg className="support-ticket-status-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={ICON_PATH_BY_VARIANT[variant]} />
        </svg>
        <span className="support-ticket-status-title">{title}</span>
      </div>
      {copy ? <p className="support-ticket-status-copy">{copy}</p> : null}
      {actions ? <div className="support-ticket-actions">{actions}</div> : null}
    </div>
  );
}
